import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
// component
import { useSnackbar } from 'notistack';
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------
LinksMoreMenu.propTypes = {
  link: PropTypes.object,
};

export default function LinksMoreMenu({ link }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          sx={{ color: 'text.secondary' }}
          onClick={() => {
            navigator.clipboard
              .writeText(`${process.env.REACT_APP_URL}/create_account_link/${link.clientId}/${link.clientToken.token}`)
              .then(() => {
                enqueueSnackbar('Link copiado', { variant: 'success' });
                setIsOpen(false);
              });
          }}
        >
          <ListItemIcon>
            <Iconify icon="fa:copy" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Copiar" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
      </Menu>
    </>
  );
}
